<template>
<div class="index" :class="'body_'+shopStyleData.mainPageCode" v-cloak>
  <!--

    * @Discription 多模板  --  UI(文宏) 提供页面 html骨架会改变 排版布局会不一样（所以进行多组件模式）  home 页面进行数据请求 然后传递给组件，组件进行渲染
    * @Email  578407090@qq.com
    * @Project 手机店铺H5
    * @Author  王连应
    * @Date  2019年8月21日
    * @dependent vue2.0

   -->
  <!--

    *模板类型值
    shop_show_default        经典模板（模板1）
    shop_show_small          小图模板（模板2）
    shop_show_big            大图模板（模板3）
    shop_show_lovely         可爱模板（模板4）
    shop_show_simple         简约模板（模板5）
    shop_show_hairAndNail    美甲没发模板（模板6）
    shop_show_healthNursing  养生护理模板（模板7）

  -->
  <!-- 模板1  模板2  模板3  模板4  模板5  模板6  模板7 -头部 -->
  <defaultHead v-bind:shopInfo="shop" v-bind:mainPageCode="shopStyleData.mainPageCode" @changectype="changectype" @gotomap="gotomap"></defaultHead>

  <!-- 博饼广告 -->
  <div class="game-banner" v-if="getdatanull(diceData)" @click="goAllActivity">
    <img :src="diceData.adPicUrl" />
  </div>

  <!-- 模板1  模板2  模板3 模板4-优惠券 -->
  <defauTicket  v-bind:mainPageCode="shopStyleData.mainPageCode" v-show="ticketDefaul"></defauTicket>
  <simpleTicket  v-bind:mainPageCode="shopStyleData.mainPageCode"  v-show="ticketHairAndNailSimple"></simpleTicket>

  <!-- 模板1-商品 -->
  <defaultGoods v-bind:goodsList="recommend" v-bind:mainPageCode="shopStyleData.mainPageCode" v-bind:takeouts="takeoutsData" v-show="goodsdefaul"></defaultGoods>
  <!-- 模板2 模板3-商品 -->
  <smallandbigGoods v-bind:goodsList="recommend" v-bind:mainPageCode="shopStyleData.mainPageCode" v-bind:takeouts="takeoutsData" v-show="goodsSmallAndBig"></smallandbigGoods>

  <!-- 底部导航 -->
  <v-footer v-bind:active="1"></v-footer>
  <!-- 购物车图标 -->
  <v-cart v-bind:alias="1"></v-cart>
</div>
</template>

<script>
  // import AMap from 'AMap';
	import swiper from '../../static/js/swiper/swiper.min.js'
  import api from '@/fetch/api'

  // 页面结构  头部    优惠券   商品列表

  // 模板组件
  // 头部
  //模板1  模板2  模板3  模板4  模板5  模板6  模板7
  import defaultHead from '@/components/style/head/shop_show_default.vue'
  // 头部End

  //优惠券
  //模板1  模板2  模板3  模板4  模板7
  import defauTicket from '@/components/style/ticket/shop_show_default.vue'
  //模板5  模板6
  import simpleTicket from '@/components/style/ticket/shop_show_hairAndNail_simple.vue'

  //优惠券 End

  //商品
  //模板1
  import defaultGoods from '@/components/style/goods/shop_show_default.vue'
  //模板2  模板3 模板4  模板5  模板6  模板7
  import smallandbigGoods from '@/components/style/goods/shop_show_small_big.vue'
  //商品 End

  // 模板组件 End

  // 底部导航
  import footer from '@/components/footer.vue'

  // 购物车按钮
  import cart from '@/components/cart.vue'

	export default {
		name: 'home',
		data() {
			return {
				shopAlias: this.$route.query.shopAlias,
				ticketdata: '',
				shop: '',
				recommend: [],
				membercards: '',
        ticketNumber: '', //优惠券数量
        shopStyleData:'',
				allgoods: 0,
        shoppingCarList: this.locget(this.$route.query.shopAlias) || {},
        diceData:'',
        ticketDefaul: false,  // 优惠券
        ticketHairAndNailSimple:false,   // 优惠券
        goodsdefaul: false,  //商品
        goodsSmallAndBig:false,   // 商品
        takeoutsData:''  //外卖设置
			}
    },
    components: {
      'v-footer':footer,
      'v-cart':cart,
      defaultHead,
      defauTicket,
      simpleTicket,
      defaultGoods,
      smallandbigGoods
    },
    methods: {
      init() {
        var data = {
          loginShopAlias:this.$route.query.shopAlias
        }
        api.getshopStyleData(this.geturl(data)).then(res => {
          this.shopStyleData = res.resultObj
          // 优惠券模板显示
          if(
            res.resultObj.mainPageCode == 'shop_show_default' //模板1
            || res.resultObj.mainPageCode == 'shop_show_small'  //模板2
            || res.resultObj.mainPageCode == 'shop_show_big'   //模板3
            || res.resultObj.mainPageCode == 'shop_show_lovely'  //模板4
            || res.resultObj.mainPageCode == 'shop_show_healthNursing'  //模板7
          ){
            this.ticketDefaul = true
          }else if(
            res.resultObj.mainPageCode == 'shop_show_simple'  //模板5
            || res.resultObj.mainPageCode == 'shop_show_hairAndNail'  //模板6
          ){
            this.ticketHairAndNailSimple = true
          }
          // 商品模板显示
          if(
            res.resultObj.mainPageCode == 'shop_show_default' //模板1
          ){
            this.goodsdefaul = true
          }else if(
            res.resultObj.mainPageCode == 'shop_show_small'
            || res.resultObj.mainPageCode == 'shop_show_big'
            || res.resultObj.mainPageCode == 'shop_show_lovely'
            || res.resultObj.mainPageCode == 'shop_show_simple'
            || res.resultObj.mainPageCode == 'shop_show_hairAndNail'
            || res.resultObj.mainPageCode == 'shop_show_healthNursing'
          ){
            this.goodsSmallAndBig = true
          }
           //商品推荐
          api.recommend(this.geturl(data))
            .then(res => {
            this.recommend = res.resultObj;
            this.$nextTick(()=>{
              new Swiper('.swiper-container-goods', {
                slidesPerView: 2.5,
                paginationClickable: true,
                spaceBetween: 6,
                observer:true,
                observeParents:true
              });
            })
          })
        })

        //店铺信息

				api.getShopInfo(this.geturl(data))
					.then(res => {
            this.shop = res.resultObj;
            if (res.resultObj.status == 0) {
              this.$router.replace({
                path: '/shop/noShop'
              })
            }
            document.title = this.shop.shopName;
            if(this.islogin() == true){
              let data = {
                loginShopAlias:this.$route.query.shopAlias
              }
							api.addmembervisitlog(data).then(res => {}, res => {})
						}
						this.share(
							this.shop.shopName,
							this.shop.shopName + '发现一家好店铺，分享给你；点我开始优惠买单吧！',
							location.href,
							this.shop.logo
						)

						localStorage.shoplogo = this.shop.logo;
						localStorage.shopname = this.shop.shopName;
						localStorage.shopdesc = this.shop.shopName + '发现一家好店铺，分享给你；点我开始优惠买单吧！';

          })

          //获取博饼信息
          api.getDiceEntry(this.geturl(data)).then(res => {
            this.diceData = res.resultObj
          })

      },
      // 收藏店铺
      changectype() {
				if(this.shop.hadAttention == false) {
					api.collection({
							"loginShopAlias": this.$route.query.shopAlias
						})
						.then(res => {
							this.shop.hadAttention = true
							this.$toast('收藏成功');
						}, res => {
							if(this.islogin() == true) {
								this.$toast(res.resultMsg);
							} else {
								this.$router.push('/user/login?shopAlias=' + this.$route.query.shopAlias);
							}
						})

				} else {
					api.cancelcollection({
							"loginShopAlias": this.$route.query.shopAlias
						})
						.then(res => {
							this.shop.hadAttention = false;
							this.$toast('取消成功');
						}, res => {
							if(this.islogin() == true) {
								this.$toast(res.resultMsg);
							} else {
								this.$router.push('/user/login?shopAlias=' + this.$route.query.shopAlias);
							}
						})
				}
      },
      // 地图跳转
      gotomap(url) {
				if(this.$route.query.comefrom == undefined) {
					this.$router.push('/map?longitude='+this.shop.longitude+'&latitude='+this.shop.latitude+'&name='+this.shop.shopName)
				} else {
					return;
				}
			},
      goAllActivity() {   //调整博饼活动页面
        if(this.diceData.activityNum >= 2){
          this.$router.push('/gamble/list?shopAlias=' + this.$route.query.shopAlias);
        }else{
          this.$router.push('/gamble/index?shopAlias=' + this.$route.query.shopAlias + '&gameAlias=' + this.diceData.gameAlias);
        }

			},
    },
    created() {
      //存储收银员员信息
      this.merPush();
			if(this.$route.query.shopAlias == undefined) {
				if(localStorage.shopAlias !== undefined) {
					this.$router.replace({
						path: '/home?shopAlias=' + localStorage.shopAlias
					})
				} else {
					this.$route.query.shopAlias = 'ivRS1K8Zg';
				}
      }
      this.init();
      this.senddatabox() //获取外卖交易设置信息


		},
		mounted() {

			var map, geolocation;
      var _this = this;
			this.$nextTick(() => {
				//加载地图，调用浏览器定位服务
				map = new AMap.Map('container', {
					resizeEnable: true
				});
				map.plugin('AMap.Geolocation', function() {
					geolocation = new AMap.Geolocation({
						enableHighAccuracy: true, //是否使用高精度定位，默认:true
						timeout: 100000, //超过10秒后停止定位，默认：无穷大
						buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
						zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
						buttonPosition: 'RB'
					});
					map.addControl(geolocation);
					geolocation.getCurrentPosition();
					AMap.event.addListener(geolocation, 'complete', _this.onComplete); //返回定位信息
					AMap.event.addListener(geolocation, 'error', _this.onError); //返回定位出错信息
				});
			})
		},
		watch: {
			'$route': function(data) {
				this.init();
      },
      "recommend": function(data) {
        // alert("1")
        // alert(JSON.stringify(this.recommend))
				this.$nextTick(()=>{
          new Swiper('.swiper-container-goods', {
            slidesPerView: 2.5,
            paginationClickable: true,
            spaceBetween: 6,
            observer:true,
            observeParents:true
          });
        })
      }
		}
	}
</script>
<style scoped>
.swiper-pagination-goods {
    display: none
  }
.body_shop_show_lovely {
  background: #ffdbdf
}
.body_shop_show_healthNursing {
  background: #ecf1ed
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/home.vue